/**
 * Which years each region actually has burned-area tiles for.
 *
 * The wildfire pyramid is sparse — a region only has tiles for years in which
 * something burned — so the year slider needs to know which of its positions
 * will actually show data. Generated by scripts/stats/generate-wildfire-years.js:
 *
 *   { "kenora": [2011, 2012, 2014, ...], "wabigoon": [2025] }
 *
 * Same loader shape as clearcutAreaStats.js.
 */

let _yearsPromise = null;

function loadWildfireYears() {
  if (!_yearsPromise) {
    // Served from the app's own origin (public/data), not the tile CDN.
    const base = process.env.PUBLIC_URL || '';
    _yearsPromise = fetch(`${base}/data/wildfire_years.json`)
      .then((r) => {
        if (!r.ok) throw new Error(`wildfire_years.json: HTTP ${r.status}`);
        return r.json();
      })
      .catch((err) => {
        console.error('[WildfireYears]', err);
        _yearsPromise = null;
        throw err;
      });
  }
  return _yearsPromise;
}

/**
 * Union of the fire years across the given regions, ascending.
 * A year is included if ANY of the selected regions burned that year.
 *
 * @param {string[]} regions - FMU ids, e.g. ['kenora', 'wabigoon']
 * @returns {Promise<number[]>}
 */
export async function getFireYearsForRegions(regions) {
  if (!Array.isArray(regions) || regions.length === 0) return [];

  const all = await loadWildfireYears();
  const union = new Set();

  for (const region of regions) {
    const key = String(region || '').toLowerCase();
    const years = all[key];
    if (Array.isArray(years)) years.forEach((y) => union.add(y));
  }

  return [...union].sort((a, b) => a - b);
}

export function clearWildfireYearsCache() {
  _yearsPromise = null;
}
